/**
 * ESC/POS command codes
 */

export const LINE_FEED = 0x0a;
export const CARRIAGE_RETURN = 0x0d;
export const FULL_CUT = [0x1d, 0x56, 0x00];
export const PRINTER_INIT = [0x1b, 0x40];
export const RASTER_BIT_IMAGE = [0x1d, 0x76, 0x30];
export const RASTER_BIT_IMAGE_MODE_NORMAL = 0x0;

// Beep command format 1: ESC B n t
// n = number of beeps (1-9)
// t = beep time (1-9) * 100ms
export const BEEP_COMMAND_SIMPLE = [0x1b, 0x42]; // ESC B

// Beep command format 2: ESC ( A pL pH fn a n m
// More widely supported on newer ESC/POS printers
// pL = 4, pH = 0 (parameter length = 4)
// fn = 48 (0x30) (function code for beeping)
// a = 2 (beep function identifier)
// n = number of beeps (1-9)
// m = beep duration (1-9) * 100ms
export const BEEP_COMMAND_ADVANCED = [0x1b, 0x28, 0x41, 0x04, 0x00, 0x30, 0x02]; // ESC ( A 04 00 30 02

